// Cierge Labs — KATLAS API client (frontend-side).
// The frontend never sees the KATLAS bearer token; all calls go through the
// app's own backend at /api/katlas/*. The backend holds the token and proxies
// to the production KATLAS node.

import { api } from "./api";

export async function fetchKatlasDiagnostics() {
  const { data } = await api.get("/katlas/diagnostics");
  return data;
}

export async function fetchKatlasStatus() {
  const { data } = await api.get("/katlas/status");
  return data;
}

export async function requestLiveSign({
  draftId,
  headline,
  selection,
  walletFingerprint,
  walletHandle,
}) {
  const { data } = await api.post("/katlas/receipts/sign", {
    draft_id: draftId || null,
    headline,
    selection,
    wallet_fingerprint: walletFingerprint || null,
    wallet_handle: walletHandle || null,
  });
  return data;
}

export async function requestVerify(envelopeId) {
  const { data } = await api.post(`/katlas/receipts/verify/${envelopeId}`);
  return data;
}
